import axios from "axios";
import { getConfig } from "./config.service";

const mainApiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Set base URL and subscription key dynamically from config
mainApiClient.interceptors.request.use(
  (config) => {
    const appConfig = getConfig();

    // Set baseURL if not already set on this request
    if (!config.baseURL) {
      config.baseURL = appConfig.apiBaseUrl;
    }

    // Set subscription key header
    if (appConfig.ocpApimSubscriptionKey) {
      config.headers["Ocp-Apim-Subscription-Key"] = appConfig.ocpApimSubscriptionKey;
    }

    try {
      // Security: Use sessionStorage (preferred) with localStorage fallback for backward compatibility
      const tokenStorage = sessionStorage.getItem("okta-token-storage")
        || localStorage.getItem("okta-token-storage");
      if (tokenStorage) {
        const parsedStorage = JSON.parse(tokenStorage);
        const token = parsedStorage?.accessToken?.accessToken;
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      }
    } catch (error) {
      // Don't log token-related errors to avoid exposing sensitive info
    }

    return config;
  },
  (error) => {
      return Promise.reject(error);
  },
);

export default mainApiClient;
